export const planCardRootStyles = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
  backgroundColor: 'background.primary',
  marginBottom: '4px',
  overflow: 'hidden',
};

export const planCardHeaderStyles = {
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '8px 10px',
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'background-color 120ms ease',
  '&:hover': {
    backgroundColor: 'background.secondary',
  },
};

export const planCardHeaderLeftStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: '6px',
  minWidth: 0,
  flex: 1,
};

export const planCardHeaderIconActiveStyles = {
  display: 'flex',
  color: 'primary.main',
};

export const planCardHeaderIconDoneStyles = {
  display: 'flex',
  color: 'success.main',
};

export const planCardHeaderIconFailedStyles = {
  display: 'flex',
  color: 'error.main',
};

export const planCardHeaderTitleStyles = {
  color: 'text.primary',
};

export const planCardCancelButtonStyles = {
  width: '24px',
  height: '24px',
  padding: 0,
  color: 'text.secondary',
  flexShrink: 0,
};

export const planCardHeaderRightStyles = {
  flexDirection: 'row',
  alignItems: 'center',
  gap: '6px',
  flexShrink: 0,
};

export const getPlanCardChevronStyles = isExpanded => ({
  display: 'inline-flex',
  color: 'text.secondary',
  transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'transform 150ms ease',
});

export const planCardBodyStyles = {
  borderTop: '1px solid',
  borderTopColor: 'divider',
  padding: '8px',
  gap: '8px',
};

export const actionPlanDepthRowStyles = {
  width: '100%',
};

export const parallelGroupStyles = {
  flexDirection: 'row',
  gap: '4px',
  flexWrap: 'wrap',
  '& > *': {
    flex: '1 1 280px',
    minWidth: 0,
  },
};
